module.exports = __webpack_public_path__ + "static/media/William Shakespeare.4c8d6b91.jpg";